<template>
    <div
        v-if="
            (googleEnable || facebookEnable || appleEnable || twitterEnable || steamEnable || psnEnable) &&
                !isToy &&
                !isDevelopers
        "
        class="third-party-container"
        data-cy="third-party-container"
    >
        <ul class="third-party list-unstyled">
            <li>
                <buttonGoogle
                    v-if="googleEnable"
                    class="social-google"
                    :tpa-type="tpaType"
                    :oauth-state="oauthState"
                    @click="tpaClick"
                ></buttonGoogle>
                <buttonFacebook
                    v-if="facebookEnable"
                    class="social-facebook"
                    :tpa-type="tpaType"
                    :oauth-state="oauthState"
                    @click="tpaClick"
                ></buttonFacebook>
                <buttonApple
                    v-if="appleEnable"
                    class="social-apple"
                    :tpa-type="tpaType"
                    :oauth-state="oauthState"
                    @click="tpaClick"
                ></buttonApple>
                <buttonTwitter
                    v-if="twitterEnable"
                    class="social-twitter"
                    :tpa-type="tpaType"
                    :oauth-state="oauthState"
                    @click="tpaClick"
                ></buttonTwitter>
                <buttonSteam v-if="steamEnable" class="social-steam" :tpa-type="tpaType"></buttonSteam>
                <buttonPSN v-if="psnEnable" class="social-PSN" :tpa-type="tpaType"></buttonPSN>
            </li>
        </ul>
    </div>
</template>

<script>
import buttonGoogle from '@/components/buttons/button-google';
import buttonFacebook from '@/components/buttons/button-facebook';
import buttonApple from '@/components/buttons/button-apple';
import buttonSteam from '@/components/buttons/button-steam';
import buttonPSN from '@/components/buttons/button-psn';
import buttonTwitter from '@/components/buttons/button-twitter';

export default {
    name: 'ThirdPartyLayout',
    components: {
        buttonGoogle,
        buttonFacebook,
        buttonApple,
        buttonSteam,
        buttonPSN,
        buttonTwitter,
    },
    props: {
        thirdPartyHeader: {
            type: String,
            default: '',
        },
        tpaType: {
            type: String,
            default: '',
        },
        oauthState: {
            type: Object,
            default: null,
        },
        hasTwitterLogin: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        productId() {
            return this.$cookie.get('ProdId');
        },
        googleEnable() {
            return true;
        },
        facebookEnable() {
            return true;
        },
        appleEnable() {
            return true;
        },
        twitterEnable() {
            return this.hasTwitterLogin;
        },
        steamEnable() {
            // 20825, 30900 = Law breakers, dos = Duel of summoner, 40100 = Hyper universe
            return (
                this.isWest() &&
                !this.$store.state.isApplication &&
                (this.productId === 'dos' || this.productId === '40100' || this.productId === '40325')
            );
        },
        psnEnable() {
            return false;
        },
        isToy() {
            return this.$store.state.appType === 'toy';
        },
        isDevelopers() {
            return this.$store.state.appType === 'developers';
        },
    },
    methods: {
        isWest() {
            return this.region === 'global';
        },
        tpaClick(type) {
            this.$emit('tpaClick', type);
            this.$store.commit('setTpaClicked', type);
            dataLayer.push({
                event: 'Start Social Account Linking',
                actionAttempted: 'link social',
                actionResult: 'confirm',
                tpaType: type,
            });
        },
    },
};
</script>

<style lang="less" scoped>
.third-party {
    padding-top: 15px;
}
@media (max-width: 740px) {
    .third-party {
        padding-top: 8px;
    }
}
</style>
